import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TaskStatus } from '../../../timelineItem';
import { MonitoringVisitsNoteProps } from '../../../../../types/task';

export const MonitoringVisitsNote: React.FC<MonitoringVisitsNoteProps> = ({ status }) => {
  const { t } = useTranslation('task');

  if (status !== TaskStatus.IN_PROGRESS && status !== TaskStatus.COMPLETED) {
    return null;
  }

  return (
    <div className="mt-4 rounded-md border border-blue-200 bg-blue-50 p-3 text-xs text-blue-800 md:text-sm">
      <div className="flex items-start gap-2">
        <InfoCircleOutlined className="mt-0.5 shrink-0 text-blue-600" />
        <span>{t('offlineMonitoringVisitsNote')}</span>
      </div>
    </div>
  );
};

export default MonitoringVisitsNote;
